<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";
import Calendar from "primevue/calendar";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { mapState } from "vuex";

// ✅ Importa a logo (garante path final no build)
import logoApvs from "@/assets/images/logo_apvs_brasil.png";

export default {
  components: {
    Layout,
    VclList,
    Calendar,
  },

  data() {
    return {
      modalExtrato: false,
      extratoConsultor: {
        debitos: [],
        creditos: [],
        total_debitos: 0,
        total_creditos: 0
      },
      loading: true,
      errored: false,
      empty: false,

      data: null,
      periodMonth: new Date(),

      // ✅ logo renderizável e capturável
      logoApvsUrl: logoApvs,
      logoApvsBase64: null,
      logoLoaded: false,
      exportingPdf: false, // 🔒 trava do botão
      comissaoEquipe: [],
      loadingEquipe: false,
    };
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),

    // Totais do Resumo por Consultor (mantido)
    resumoTotals() {
      const list = this.data?.resumoConsultores || [];
      const totalConsultores = list.length;

      const sum = (arr, key) =>
        arr.reduce((acc, cur) => acc + (Number(cur?.[key]) || 0), 0);

      return {
        totalConsultores,
        arrecadado: sum(list, "arrecadado"),
        meta: sum(list, "meta"),
        comissao: sum(list, "comissao"),
      };
    },

    // Totais Créditos/Débitos (mantido)
    creditosDebitosTotals() {
      const items = this.data?.creditosDebitos || [];

      const norm = (t) => String(t || "").toLowerCase();
      const isCredito = (t) => norm(t).includes("cr");
      const isDebito = (t) => norm(t).includes("dé") || norm(t).includes("deb");

      const creditos = items.filter((i) => isCredito(i.tipo));
      const debitos = items.filter((i) => isDebito(i.tipo));

      const sum = (arr) =>
        arr.reduce((acc, cur) => acc + (Number(cur?.valor) || 0), 0);

      return {
        creditosCount: creditos.length,
        debitosCount: debitos.length,
        creditosValue: sum(creditos),
        debitosValue: sum(debitos),
      };
    },

    comissaoEquipeTotals() {
      const list = this.comissaoEquipe || [];

      const sum = (arr, key) =>
        arr.reduce((acc, cur) => acc + (Number(cur?.[key]) || 0), 0);

      return {
        totalLinhas: list.length,
        arrecadado: sum(list, "arrecadado"),
        qtd_boletos: sum(list, "qtd_boletos"), // 👈 NOVO
        valor: sum(list, "valor"),
      };
    },

    // ✅ Novos campos do Perfil (com fallback para não quebrar)
    perfilTipoLabel() {
      // novo: data.header.tipo_label
      // fallback: data.userType (antigo)
      return (
        this.data?.header?.tipo_label ||
        this.data?.userType ||
        "Não identificado"
      );
    },

    perfilNivelLabel() {
      // novo: data.header.nivel_hierarquico_label
      // fallback: hierarchyLevel antigo
      const label = this.data?.header?.nivel_hierarquico_label;
      if (label) return label;

      const lvl = this.data?.header?.hierarchyLevel;
      return this.getLevelLabel(lvl);
    },

    perfilNivelAtingidoLabel() {
      const header = this.data?.header;
      if (!header) return "Não identificado";

      const type = String(header.user_regional_type || "").toLowerCase();

      // 🔹 REGRA DEFINITIVA POR TIPO
      if (type === "executiva") return "Executiva";
      if (type === "gerente-regional") return "Gerente Regional";
      if (type === "gerente-master") return "Gerente Master";
      if (type === "diretor") return "Diretor";

      // 🔹 fallback (não deveria acontecer)
      return "Executiva";
    },

  },

  methods: {
    /* ===========================
       📅 PERÍODO
       - Exibe o mês selecionado normalmente
       - MAS: envia para API o mês anterior (regra solicitada)
    =========================== */
    async abrirExtratoConsultor(iduser) {
      try {
        const period = this.getPeriod(); // yyyy-m
        const [year, month] = period.split("-");

        const response = await api.get(
          `vitalicio/truck/extrato-consultor?iduser=${iduser}&month=${month}&year=${year}`
        );

        if (response.data.status === "success") {
          this.extratoConsultor = response.data.data;
          this.modalExtrato = true;
        }

      } catch (err) {
        console.error(err);
        this.$toast.error("Erro ao carregar extrato do consultor");
      }
    },
    // ✅ regra do -1 mês para a API
    getPeriod() {
      const base = this.periodMonth || new Date();
      const d = new Date(base);
      d.setDate(1);
      d.setMonth(d.getMonth() - 1);

      const month = String(d.getMonth() + 1).padStart(2, "0");

      return `${d.getFullYear()}-${month}`;
    },

    // layout continua exibindo o mês escolhido
    showPeriod() {
      const d = this.periodMonth || new Date();
      return `${d.getMonth() + 1}/${d.getFullYear()}`;
    },

    showPeriodExtenso() {
      const base = this.periodMonth || new Date();
      const fechamento = new Date(base);

      const meses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];

      const mesFechamentoIndex = fechamento.getMonth();
      const anoFechamento = fechamento.getFullYear();

      // 🔹 Calcula competência (-1 mês)
      const competencia = new Date(fechamento);
      competencia.setDate(1);
      competencia.setMonth(competencia.getMonth() - 1);

      const mesCompetenciaIndex = competencia.getMonth();
      const anoCompetencia = competencia.getFullYear();

      return `Fechamento de ${meses[mesFechamentoIndex]} de ${anoFechamento} competência ${meses[mesCompetenciaIndex]} de ${anoCompetencia}`;
    },

    /* ===========================
       🔄 LOAD (mantido)
    =========================== */
    load() {
      this.loading = true;
      this.errored = false;
      this.empty = false;
      this.data = null;

      api
        .get(`vitalicio/truck/comissionamento?date=${this.getPeriod()}`)
        .then((response) => {
          if (response.data.status === "success") {
            this.data = response.data.data;

            if (!this.data) {
              this.empty = true;
              return;
            }

            // ✅ CHAMA A API DA EQUIPE AQUI
            if (this.data.userType === "Regional") {
              this.loadComissionamentoEquipe();
            }
          } else {
            this.errored = true;
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });

    },

    /* ===========================
       🎨 PERFIL HELPERS (mantido)
    =========================== */
    getLevelLabel(level) {
      const n = Number(level);
      if (!n) return "Não identificado";
      if (n === 1) return "Consultor";
      if (n === 2) return "Consultor Líder";
      if (n === 3) return "Regional Home Office";
      return "Regional Executiva";
    },

    getLevelColor(level) {
      const n = Number(level);
      if (!n) return "#EF4444";
      if (n === 1) return "#3B82F6";
      if (n === 2) return "#1E40AF";
      if (n === 3) return "#14B8A6";
      return "#7C3AED";
    },

    // ✅ agora colore pelo tipo_label quando existir, senão mantém o antigo
    getTypeColor(type) {
      const t = String(type || "").toLowerCase();
      if (t.includes("regional") || t.includes("gerente")) return "#10B981";
      return "#3B82F6";
    },

    /* ===========================
       🧾 EXPORT PDF (mantido)
    =========================== */
    async exportPdf() {
      if (this.exportingPdf) return;

      this.exportingPdf = true;

      let element = null;
      let originalWidth = "";

      try {
        element = document.getElementById("report-pdf");
        if (!element) return;

        originalWidth = element.style.width;

        document.body.classList.add("pdf-export");
        element.classList.add("pdf-export");

        element.style.width = "1300px";

        await this.$nextTick();

        const imgs = element.querySelectorAll("img");
        await Promise.all(
          Array.from(imgs).map((img) => {
            if (img.complete) return Promise.resolve();
            return new Promise((resolve) => {
              img.onload = resolve;
              img.onerror = resolve;
            });
          })
        );

        if (!this.logoApvsBase64) {
          this.logoApvsBase64 = await this.loadImageAsBase64(this.logoApvsUrl);
          await this.$nextTick();
        }

        const canvas = await html2canvas(element, {
          scale: 2,
          backgroundColor: "#ffffff",
          windowWidth: element.offsetWidth,
          windowHeight: element.scrollHeight,
        });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const imgHeight = (canvas.height * pageWidth) / canvas.width;

        let y = 0;
        while (y < imgHeight) {
          pdf.addImage(imgData, "PNG", 0, -y, pageWidth, imgHeight);
          y += pageHeight;
          if (y < imgHeight) pdf.addPage();
        }

        pdf.save(`Relatorio_Comissionamento_${this.showPeriod()}.pdf`);
      } catch (error) {
        console.error("Erro ao exportar PDF:", error);
      } finally {
        if (element) {
          element.style.width = originalWidth || "";
          element.classList.remove("pdf-export");
        }

        document.body.classList.remove("pdf-export");
        this.logoApvsBase64 = null;
        this.exportingPdf = false;

        if (element) void element.offsetHeight;
      }
    },

    async loadImageAsBase64(src) {
      const response = await fetch(src);
      const blob = await response.blob();

      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },

    onLogoLoaded() {
      this.logoLoaded = true;
    },

    loadComissionamentoEquipe() {
      this.loadingEquipe = true;

      api
        .get(`vitalicio/truck/comissionamento-equipe?date=${this.getPeriod()}`)
        .then((res) => {
          if (res.data.status === "success") {
            this.comissaoEquipe = res.data.data;
          }
        })
        .finally(() => {
          this.loadingEquipe = false;
        });
    },

  },

  mounted() {
    this.load();
  },

  watch: {
    periodMonth() {
      this.load();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">Dashboard</router-link>
      </li>
      <li class="breadcrumb-item">APVS Truck</li>
      <li class="breadcrumb-item active">Comissionamento</li>
    </ol>

    <div class="page-title-box mb-3">
      <h3>Comissionamento</h3>
    </div>

    <div class="filter-bar d-flex mb-3">
      <b-dropdown variant="outline-light" ref="periodDropdown">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <small class="text-secondary">filtrar período</small>
              <div class="font-weight-600">{{ showPeriod() }}</div>
            </div>
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </template>

        <b-dropdown-group>
          <div
            class="dropdown-calendar-wrapper"
            @mousedown.stop
            @click.stop
            @touchstart.stop
          >
            <Calendar
              v-model="periodMonth"
              view="month"
              dateFormat="yy-mm-dd"
              inline
              style="width: 250px"
            />
          </div>
        </b-dropdown-group>
      </b-dropdown>

      <b-button variant="primary" class="btn-export-pdf" @click="exportPdf">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="pdf-icon"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M14 3v4a1 1 0 0 0 1 1h4" />
          <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" />
          <path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6" />
          <path d="M17 18h2" />
          <path d="M20 15h-3v6" />
          <path
            d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
          />
        </svg>
      </b-button>
    </div>

    <!-- ✅ AQUI É O QUE VAI PRO PDF -->
    <div id="report-pdf">
      <div class="card">
        <div class="card-body min-vh-25">
          <div v-if="errored" class="text-center">
            Pedimos desculpas, não podemos recuperar informações neste momento.
          </div>

          <vcl-list v-else-if="loading" class="col-md-6" />

          <div
            v-else-if="empty"
            class="text-center min-vh-25 d-flex align-items-center justify-content-center"
          >
            <strong>Nenhuma informação no período.</strong>
          </div>

          <div v-else>
            <div class="report-top mb-4">
              <div class="report-top-bar">
                <div class="report-top-title">
                  <div class="t1">Relatório de Comissionamento</div>
                  <div class="t2">{{ showPeriodExtenso() }}</div>
                </div>
              </div>

              <div class="report-top-logo">
                <img
                  ref="logoPdf"
                  :src="logoApvsBase64 || logoApvsUrl"
                  alt="APVS Truck"
                  @load="onLogoLoaded"
                />
              </div>
            </div>
              
            <!-- FECHAMENTO -->
            <div class="card mb-3">
              <div class="card-body">
                <div class="card-title-custom">Fechamento</div>

                <div class="row align-items-stretch">

                  <!-- =========================
                      🔵 1º QUADRANTE
                      PERFIL
                  ========================== -->
                  <div class="col-12 col-md-4 d-flex">
                    <div class="card w-100 h-100">
                      <div class="card-title-custom">Perfil</div>

                      <div class="meta-table">

                        <!-- HEADER (MESMO PADRÃO) -->
                        <div class="meta-row meta-head">
                          <div class="w-100">NOME</div>
                        </div>

                        <!-- VALOR NOME -->
                        <div class="meta-row meta-values">
                          <div class="meta-big text-center w-100">
                            {{ account.user.name }}
                          </div>
                        </div>

                        <!-- HEADER INFERIOR -->
                        <div class="meta-row meta-head meta-head-2">
                          <div>TIPO</div>
                          <div>NÍVEL HIERÁRQUICO</div>
                        </div>

                        <!-- VALORES INFERIORES -->
                        <div class="meta-row meta-values meta-values-2">
                          <div class="meta-mid">
                            {{ perfilTipoLabel }}
                          </div>
                          <div class="meta-mid">
                            {{ perfilNivelLabel }}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <!-- =========================
                      🔵 2º QUADRANTE
                      META BATIDA NO MÊS
                  ========================== -->
                  <div class="col-12 col-md-4 d-flex">
                    <div class="card w-100 h-100">

                      <div class="card-title-custom">
                        Meta Batida no Mês
                      </div>

                      <div class="meta-table">

                        <div class="meta-row meta-head">
                          <div>PRODUÇÃO</div>
                          <div>NÍVEL</div>
                          <div>PERCENTUAL</div>
                        </div>

                        <div class="meta-row meta-values">
                          <div class="meta-big">
                            {{ data.userType === 'Consultor'
                              ? data.comissionamentoProprio.meta_propria
                              : data.comissionamentoProprio.meta }}
                          </div>

                          <div class="meta-mid">
                            {{ data.header.nivel_atingido_label }}
                          </div>

                          <div class="meta-big">
                            {{ Number(data.comissionamentoProprio.percent || 0).toFixed(2) }}%
                          </div>
                        </div>

                        <div
                          v-if="data.userType === 'Consultor'"
                          class="meta-row meta-head meta-head-2"
                        >
                          <div>PRÓPRIA</div>
                          <div>HIERARQUIA</div>
                        </div>

                        <div
                          v-if="data.userType === 'Consultor'"
                          class="meta-row meta-values meta-values-2"
                        >
                          <div class="meta-big">
                            {{ data.comissionamentoProprio.meta_propria }}
                          </div>
                          <div class="meta-big">
                            {{ data.comissionamentoProprio.meta_hierarquia }}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <!-- =========================
                      🟢 3º QUADRANTE
                      FECHAMENTO FINANCEIRO
                  ========================== -->
                  <div class="col-12 col-md-4 d-flex">
                    <div class="card w-100 h-100">

                      <div class="card-title-custom">
                        Fechamento Financeiro
                      </div>

                      <div class="fechamento-item bg-green">
                        <strong>Arrecadação Própria</strong>
                        <span>{{ data.comissionamentoProprio.arrecadado | currency }}</span>
                      </div>

                      <div class="fechamento-item bg-green">
                        <strong>Total de Boletos Pagos</strong>
                        <span>{{ data.fechamento.qtd_boletos }}</span>
                      </div>

                      <div class="fechamento-item bg-green">
                        <strong>Comissão Própria</strong>
                        <span>{{ data.fechamento.comissao_propria | currency }}</span>
                      </div>

                      <div
                        v-if="data.userType === 'Regional'"
                        class="fechamento-item bg-green"
                      >
                        <strong>Comissão Hierarquia</strong>
                        <span>{{ data.fechamento.comissao_hierarquia | currency }}</span>
                      </div>

                      <div
                        v-if="data.userType === 'Regional'"
                        class="fechamento-item bg-red"
                      >
                        <strong>Pagamento para Consultores</strong>
                        <span>-{{ data.fechamento.pagamento_consultores | currency }}</span>
                      </div>

                      <div class="fechamento-item bg-green">
                        <strong>Créditos</strong>
                        <span>{{ data.fechamento.creditos | currency }}</span>
                      </div>

                      <div class="fechamento-item bg-red">
                        <strong>Débitos</strong>
                        <span>-{{ data.fechamento.debitos | currency }}</span>
                      </div>

                      <div class="fechamento-total">
                        <strong>Saldo Final</strong>
                        <span>{{ data.fechamento.total | currency }}</span>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>            

            <!-- Comissionamento Equipe -->
            <div v-if="data.userType === 'Regional'" class="card mb-3">
              <div class="card-body">
                <div class="card-title-custom">Comissionamento recebido da hierarquia de Regionais</div>

                <div v-if="loadingEquipe" class="text-center py-4">
                  Carregando dados da equipe...
                </div>

                <div v-else class="table-responsive">
                  <table class="table table-hover mb-0 table-cards">
                    <thead>
                      <tr>
                        <th>Regional</th>
                        <th>Arrecadado</th>
                        <th>Qtd. Boletos</th>
                        <th>%</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="r in comissaoEquipe" :key="r.idregional">
                        <td data-label="Regional">{{ r.regional }}</td>
                        <td data-label="Arrecadado">{{ r.arrecadado | currency }}</td>
                        <td data-label="Qtd. Boletos">{{ r.qtd_boletos }}</td>
                        <td data-label="%">{{ r.percent }}</td>
                        <td data-label="Valor">{{ r.valor | currency }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="totals-row">
                        <td data-label="Total"><strong>{{ comissaoEquipeTotals.totalLinhas }} regional(is)</strong></td>
                        <td data-label="Arrecadado"><strong>{{ comissaoEquipeTotals.arrecadado | currency }}</strong></td>
                        <td data-label="Qtd. Boletos"><strong>{{ comissaoEquipeTotals.qtd_boletos }}</strong></td>
                        <td data-label="%"><strong>-</strong></td>
                        <td data-label="Valor"><strong>{{ comissaoEquipeTotals.valor | currency }}</strong></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <!-- EXTRATO DA HIERARQUIA DE CONSULTORES -->
            <div v-if="data.userType === 'Regional'" class="card mb-3">
              <div class="card-body">

                <div class="card-title-custom">
                  Extrato da Hierarquia de Consultores
                </div>

                <!-- =========================
                    RESUMO SUPERIOR FINAL
                ========================== -->
                <div class="row mb-4 mt-3 resumo-dashboard">

                  <!-- COLUNA ESQUERDA -->
                  <div class="col-md-6 d-flex flex-column gap-2">

                    <div class="resumo-left bg-green">
                      <span>Consultores com Meta Alcançada</span>
                      <strong>{{ data.extratoConsultores.resumo.consultores_meta_alcancada }}</strong>
                    </div>

                    <div class="resumo-left bg-green">
                      <span>Comissionamento Total dos Consultores</span>
                      <strong>{{ data.extratoConsultores.resumo.comissionamento_total | currency }}</strong>
                    </div>

                    <div class="resumo-left bg-red">
                      <span>Consultores com Saldo Negativo</span>
                      <strong>{{ data.extratoConsultores.resumo.consultores_saldo_negativo }}</strong>
                    </div>

                    <div class="resumo-left bg-red">
                      <span>Total de Débitos dos Consultores</span>
                      <strong>{{ data.extratoConsultores.resumo.total_debitos | currency }}</strong>
                    </div>

                  </div>

                  <!-- COLUNA DIREITA -->
                  <div class="col-md-6 d-flex flex-column gap-2">

                    <!-- ALTURA = 2 CARDS DA ESQUERDA -->
                    <div class="resumo-right bg-green flex-grow-1">
                      <div class="resumo-title">
                        Total de Arrecadação dos Consultores
                      </div>
                      <div class="resumo-value">
                        {{ data.extratoConsultores.resumo.total_arrecadado | currency }}
                      </div>
                    </div>

                    <!-- ALTURA = 2 CARDS DA ESQUERDA -->
                    <div class="resumo-right bg-red flex-grow-1">
                      <div class="resumo-title">
                        Total de Repasse para a Hierarquia
                      </div>
                      <div class="resumo-value">
                        {{ data.extratoConsultores.resumo.total_repasse | currency }}
                      </div>
                    </div>

                  </div>
                </div>
                <!-- =========================
                    TABELA
                ========================== -->
                <div class="table-responsive">
                  <table class="table table-hover mb-0 table-cards">

                    <thead>
                      <tr>
                        <th colspan="7" class="text-center bg-primary text-white">
                          RECEITAS
                        </th>
                        <th colspan="4" class="text-center bg-dark text-white">
                          DESPESAS
                        </th>
                      </tr>

                      <tr>
                        <!-- RECEITAS -->
                        <th>Consultor</th>
                        <th>Arrecadado</th>
                        <th>Meta Própria</th>
                        <th>Meta Hierarquia</th>
                        <th>%</th>
                        <th>Comissão</th>
                        <th>Crédito</th>

                        <!-- DESPESAS -->
                        <th>Débito</th>
                        <th>Saldo</th>
                        <th>Repasse</th>
                        <th>Ações</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="c in data.extratoConsultores.linhas"
                        :key="c.iduser"
                      >
                        <!-- RECEITAS -->
                        <td data-label="Consultor">{{ c.consultor }}</td>
                        <td data-label="Arrecadado">{{ c.arrecadado | currency }}</td>
                        <td data-label="Meta Própria">{{ c.meta_propria }}</td>
                        <td data-label="Meta Hierarquia">{{ c.meta_hierarquia }}</td>
                        <td data-label="%">{{ c.percent }}%</td>
                        <td data-label="Comissão">{{ c.comissao | currency }}</td>

                        <td class="text-success" data-label="Crédito">
                          {{ c.creditos | currency }}
                        </td>

                        <!-- DESPESAS -->
                        <td class="text-danger" data-label="Débito">
                          {{ c.debitos | currency  }}
                        </td>
                        
                        <td :class="c.saldo < 0 ? 'text-danger' : 'text-success'" data-label="Saldo">
                          {{ c.saldo | currency }}
                        </td>

                        <td class="text-danger" data-label="Repasse">
                          {{ c.repasse | currency }}
                        </td>

                        <td>
                          <button
                            class="btn btn-outline-primary btn-sm"
                            @click="abrirExtratoConsultor(c.iduser)"
                          >
                            <i class="mdi mdi-magnify"></i>
                            <span class="d-md-none ml-2">Ver extrato do consultor</span>
                          </button>
                        </td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
            <!-- CRÉDITOS E DÉBITOS -->
            <div class="card">
              <div class="card-body">
                <div class="card-title-custom">Créditos e Débitos</div>
                <div class="table-responsive">
                  <table class="table mb-0 table-cards">
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Descrição</th>
                        <th class="text-right">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(i, idx) in data.creditosDebitos"
                        :key="idx"
                        :class="{ 'text-danger': i.valor < 0 }"
                      >
                        <td data-label="Tipo">{{ i.tipo }}</td>
                        <td data-label="Descrição">{{ i.descricao }}</td>
                        <td class="text-right" data-label="Valor">{{ i.valor | currency }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="totals-row">
                        <td data-label="Total"><strong>Crédito</strong></td>
                        <td data-label="Descrição"><strong>{{ creditosDebitosTotals.creditosCount }} linha(s)</strong></td>
                        <td class="text-right" data-label="Valor">
                          <strong>{{ creditosDebitosTotals.creditosValue | currency }}</strong>
                        </td>
                      </tr>
                      <tr class="totals-row text-danger">
                        <td data-label="Total"><strong>Débito</strong></td>
                        <td data-label="Descrição"><strong>{{ creditosDebitosTotals.debitosCount }} linha(s)</strong></td>
                        <td class="text-right" data-label="Valor">
                          <strong>{{ creditosDebitosTotals.debitosValue | currency }}</strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="modalExtrato"
      title="Extrato Financeiro do Consultor"
      size="lg"
      hide-footer
    >
      <!-- DÉBITOS -->
      <h6 class="text-danger mb-2">Débitos</h6>
      <table class="table table-sm">
        <tr v-for="(d, i) in extratoConsultor.debitos" :key="i">
          <td>{{ d.vit_description }}</td>
          <td class="text-end text-danger">
            R$ {{ d.vit_value.toFixed(2) }}
          </td>
        </tr>
      </table>

      <div class="text-end fw-bold text-danger mb-4">
        Total Débitos: R$ {{ extratoConsultor.total_debitos.toFixed(2) }}
      </div>

      <!-- CRÉDITOS -->
      <h6 class="text-success mb-2">Créditos</h6>
      <table class="table table-sm">
        <tr v-for="(c, i) in extratoConsultor.creditos" :key="i">
          <td>{{ c.vit_description }}</td>
          <td class="text-end text-success">
            R$ {{ c.vit_value.toFixed(2) }}
          </td>
        </tr>
      </table>

      <div class="text-end fw-bold text-success">
        Total Créditos: R$ {{ extratoConsultor.total_creditos.toFixed(2) }}
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
/* (SEU CSS ORIGINAL — sem mudanças) */
.report-top {
  position: relative;
  margin-top: 6px;
}

.report-top-bar {
  background: var(--st-brand);
  border-radius: var(--st-radius-lg);
  padding: 26px 18px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
}

.report-top-title {
  color: var(--st-text-inverse);
  z-index: 1;
  max-width: 100%;
}

.report-top-title .t1 {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.15;
}

.report-top-title .t2 {
  font-size: 16px;
  font-weight: 500;
  opacity: 0.95;
  margin-top: 6px;
}

.report-top-logo {
  position: absolute;
  left: 28px;
  top: 50%;
  transform: translateY(-50%);
  width: 160px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.report-top-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.35));
}

.card {
  width: 100%;
}


@media (max-width: 1232px) {
  .report-top-logo {
    display: none;
  }
}
@media (max-width: 768px) {
  .report-top-logo {
    display: none;
  }
  .report-top-bar {
    padding: 20px 14px;
  }
  .report-top-title .t1 {
    font-size: 22px;
  }
  .report-top-title .t2 {
    font-size: 14px;
  }
}

:global(body.pdf-export) .report-top-logo {
  display: flex !important;
}
:global(body.pdf-export) .report-top-bar {
  overflow: visible !important;
}

.card-title-custom {
  background: var(--st-brand);
  color: var(--st-text-inverse);
  padding: 12px 16px;   /* normal */
  border-radius: var(--st-radius-lg);
  text-align: center;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 0;
}

.label-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}

.badge-custom {
  color: var(--st-text-inverse);
  padding: 6px 14px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 13px;
  display: inline-block;
}

.totals-row {
  background: var(--st-canvas);
  border-top: 2px solid var(--st-border-soft);
}

.totals-row td {
  vertical-align: middle;
}

.fechamento-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-radius: var(--st-radius);
  margin-bottom: 10px;
  font-size: 14px;
}

.fechamento-item strong {
  font-weight: 700;
}

.fechamento-item span {
  font-weight: 600;
}

.bg-green {
  background: var(--st-success-soft);
  color: var(--st-success-strong);
}

.bg-red {
  background: var(--st-danger-soft);
  color: var(--st-danger-strong);
}

.fechamento-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: var(--st-radius);
  background: var(--st-text);
  color: var(--st-text-inverse);
  font-size: 15px;
  font-weight: 700;
}

#report-pdf.pdf-export .report-top-logo {
  display: flex !important;
}
#report-pdf.pdf-export .report-top-bar {
  overflow: visible !important;
}

.bg-name {
  background: var(--st-success);
  color: var(--st-text-inverse);
  padding: 6px 14px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 13px;
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meta-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--st-text);
  margin-bottom: 10px;
  text-transform: uppercase;
}

.meta-value {
  font-size: 22px;
  font-weight: 800;
  color: var(--st-success-strong);
}

.meta-grid-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.meta-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
}

.meta-values {
  background: var(--st-canvas);
  color: var(--st-success-strong);
  font-size: 22px;
  font-weight: 800;
  padding: 26px 0;
}

.fechamento-title {
  margin-bottom: 24px;
}

.fechamento-meta,
.fechamento-financeiro {
  height: 100%;
  display: flex;
  flex-direction: column;
}


/* Área da "tabela" */
.meta-table {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* Linhas */
.meta-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.meta-head {
  height: 72px;              /* ⬅ controlado */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  text-align: center;
  font-weight: 700;
  background: var(--st-canvas);
  border-bottom: 1px solid var(--st-border-soft);
}


.meta-head div {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  border-right: 1px solid var(--st-border-soft); /* ⬅ divisória vertical */
}

.meta-head div:last-child {
  border-right: none;
}


/* Valores */
.meta-values {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  text-align: center;
  background: var(--st-success-soft);
}

.meta-values div {
  padding: 24px 8px;
  border-right: 1px solid var(--st-border-soft);
}

.meta-values div:last-child {
  border-right: none;
}


/* Tipografia */
.meta-big {
  font-size: 30px;
  font-weight: 800;
  color: var(--st-success-strong); /* mesmo verde do bg-green */
}

.meta-mid {
  font-size: 17px;
  font-weight: 700;
  color: var(--st-success-strong);
}

/* Espaçamento do título principal do Fechamento */
.fechamento-wrapper > .card-title-custom {
  margin-bottom: 20px;
}

.resumo-dashboard {
  row-gap: 12px;
}

/* ESQUERDA */
.resumo-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: var(--st-radius-lg);
  font-size: 14px;
}

.resumo-left span {
  font-weight: 700;
  color: var(--st-brand);
}

.resumo-left strong {
  font-size: 16px;
  font-weight: 800;
}

/* DIREITA */
.resumo-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: var(--st-radius-lg);
  padding: 16px;
  text-align: center;
}

.resumo-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--st-brand);
  margin-bottom: 10px;
}

.resumo-value {
  font-size: 20px;
  font-weight: 800;
}

/* gap compatível com bootstrap */
.gap-2 {
  gap: 12px;
}
/* Centraliza cabeçalhos e valores das colunas financeiras */
.table thead th:nth-child(n+2):nth-child(-n+10),
.table tbody td:nth-child(n+2):nth-child(-n+10) {
  text-align: center;
  vertical-align: middle;
}

/* Título principal do card (Perfil) */
.card-title-custom {
  margin-bottom: 28px; /* espaço entre "Perfil" e os labels */
}

/* Labels: Nome, Tipo, Nível... */
.label-title {
  margin-bottom: 10px;
  font-weight: 600;
  color: var(--st-text);
}

/* Opcional: ajuste fino nos cards internos */
.card-body .row {
  margin-top: 4px;
}

/* Perfil: 1 coluna no topo */
.meta-head .w-100,
.meta-values .w-100 {
  grid-column: 1 / -1;
}

/* Perfil: header inferior com 2 colunas */
.meta-head-2 {
  grid-template-columns: repeat(2, 1fr);
}

/* Perfil: valores inferiores com 2 colunas */
.meta-values-2 {
  grid-template-columns: repeat(2, 1fr);
}

/* Centralização correta */
.meta-values-2 div {
  text-align: center;
}

/* Ajuste fino de altura para alinhar com os outros quadrantes */
.card .meta-table {
  height: calc(100% - 52px);
}

/* Alinha corretamente o total com as colunas */
.table tfoot td {
  text-align: center;
  vertical-align: middle;
}

/* Primeira coluna (Regional / Total) alinhada à esquerda */
.table tfoot td:first-child {
  text-align: left;
}


/* ── Painéis de fechamento no celular ─────────────────────
   As grades `meta-grid`/`meta-head`/`meta-values` são `repeat(3, 1fr)`
   com números em 22px/800. Numa tela de 380px cada coluna fica com ~100px
   e um valor como "R$ 12.345,67" estoura a célula. Abaixo de md a escala
   tipográfica cede, a altura fixa do cabeçalho vira mínima e o texto pode
   quebrar — as três colunas continuam lado a lado, que é o que torna a
   comparação legível. */
@media (max-width: 767.98px) {
  .meta-head {
    height: auto;
    min-height: 56px;
    font-size: 12px;
  }

  .meta-head div {
    padding: 8px 4px;
    overflow-wrap: anywhere;
  }

  .meta-values {
    font-size: 16px;
    padding: 0;
  }

  .meta-values div {
    padding: 14px 4px;
    overflow-wrap: anywhere;
  }

  .card-title-custom {
    font-size: 14px;
    padding: 10px 12px;
  }

  /* No card empilhado o rodapé de totais também vira "rótulo → valor",
     então a centralização de coluna não se aplica mais. */
  .table tfoot td {
    text-align: left;
  }
}
</style>
